import Price from "./Price";
import AnalyticsPrice from "./AnalyticsPrice";

export { Price, AnalyticsPrice };
export default { Price, AnalyticsPrice };
